import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./SelectRecoveryMethod.module.css"; 
import Swal from "sweetalert2";
import axios from "axios";

function SelectRecoveryMethod() {
	const navigate = useNavigate();
	const location = useLocation();
	const cuil = location.state.cuil;
	const id = cuil;

	const handleOption = (route) => {
		// Redirigir a la ruta especificada
		navigate(route);
	};

	const handleGoogleAuthenticator = async () => {
		try {
			// Realizar la petición al servidor para configurar la autenticación de dos factores
			const res = await axios.post(
				`${process.env.REACT_APP_AUTHENTICATOR_GOOGLE_SETUP_TWO_FACTOR}/${id}`
			);
			
			if (res.data.success) {
				navigate("/authenticatorGoogle", {
					state: {
						qrCodeImageUrl: res.data.qrCodeImageUrl,
						secret: res.data.secret,
						cuil: cuil,
					}});
				} else {
					Swal.fire({
						icon: "error",
						title: "Oops... Algo salio mal",
						text: res.data.message,
					});
				}
		
					
		} catch (error) {
			// Manejar cualquier otro error
			Swal.fire({
				icon: "error",
				title: "Oops...",
				text: error.message,
			});
		}
	};


	return (
		<div className={styles.container}>
			<div className={styles.header}>
				¿Cómo desea cambiar su contraseña?
			</div>
			<div className={styles.form}>
				<button
					className={styles.authButton}
					onClick={() => handleOption("/gmailRecovery")}
				>
					Gmail
				</button>
				<button
					className={styles.authButton}
					onClick={handleGoogleAuthenticator}
				>
					Google Authenticator
				</button>

			</div>
		</div>
	);
}

export default SelectRecoveryMethod;